import request from '@/utils/request'
import API from './api'


//题目管理-打标签-关闭任务提示
export function getCloseTagTaskMsgAPI(data) {
  return request({
    url: API.CLOSE_TAG_TASK_MSG,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/API/set-tag.js